const menuBtn = document.querySelector('.menu-btn');
const navMenu = document.querySelector('.nav-menu');

if (menuBtn && navMenu) {
  menuBtn.addEventListener('click', () => {
    const isOpen = menuBtn.getAttribute('aria-expanded') === 'true';
    menuBtn.setAttribute('aria-expanded', String(!isOpen));
    navMenu.classList.toggle('is-open');
  });
}

// Submenu toggles (click/tap to open — hover still works for mouse users via CSS)
const closeAllSubmenus = (except) => {
  document.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach((btn) => {
    if (btn !== except) btn.setAttribute('aria-expanded', 'false');
  });
};

document.querySelectorAll('.submenu-toggle').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    closeAllSubmenus(toggle);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
});

document.addEventListener('click', (e) => {
  if (!e.target.closest('.nav-item')) closeAllSubmenus();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeAllSubmenus();
});
